import { WidgetsMileageSummaryModel } from "@interfaces/models";
import { formatMileage, formatAmount } from "@utils/index";

export const MileageSummaryWidget = ({
  summary,
  onDetails,
}: {
  summary: WidgetsMileageSummaryModel;
  onDetails: () => void;
}) => (
  <button
    type={"button"}
    onClick={onDetails}
    className="group flex h-40 cursor-pointer flex-col gap-y-4 rounded-lg bg-primary-316 px-6 py-4 text-black-100 hover:text-primary-300 md:h-auto"
  >
    <div className="flex w-full items-center justify-between border-b border-b-black-8 pb-4 font-bold">
      <p>Mileage</p>
      <p>
        {summary.totalMiles
          ? formatMileage(summary.totalMiles)
          : formatAmount(summary.totalMileageCost, "£")}
      </p>
    </div>
    <div className="flex w-full items-center justify-between">
      <p className="text-black-54 group-hover:text-primary-300/55">Business:</p>
      <p>
        {summary.businessMiles
          ? formatMileage(summary.businessMiles)
          : formatMileage(summary.totalBusinessMiles ?? 0)}
      </p>
    </div>
    {summary.privateMiles && (
      <div className="flex w-full items-center justify-between">
        <p className="text-black-54 group-hover:text-primary-300/55">
          Private:
        </p>
        <p>{formatMileage(summary.privateMiles)}</p>
      </div>
    )}
  </button>
);
